/**
 * Human-readable durations for people surfaces (11F.7).
 *
 * Shared by the Student and Staff detail rails. Kept out of the component
 * files so those export only components (react-refresh), and so the
 * month-boundary arithmetic below is unit-testable on its own.
 */

/** Whole years + months, the way a school refers to a child's age ("8y 3m"). */
export function formatAge(dob: string | null | undefined): string | null {
  if (!dob) return null;
  const born = new Date(dob);
  if (Number.isNaN(born.getTime())) return null;
  const now = new Date();
  let months = (now.getFullYear() - born.getFullYear()) * 12 + (now.getMonth() - born.getMonth());
  // Not yet reached this month's anniversary day — the month isn't complete.
  if (now.getDate() < born.getDate()) months -= 1;
  if (months < 0) return null; // future date of birth — show nothing, not "-1y"
  const years = Math.floor(months / 12);
  return `${years}y ${months % 12}m`;
}

/** Elapsed time since a start date — "how long they've been with us". */
export function formatTenure(startedAt: string | null | undefined): string | null {
  if (!startedAt) return null;
  const start = new Date(startedAt);
  if (Number.isNaN(start.getTime())) return null;
  const now = new Date();
  let months = (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth());
  if (now.getDate() < start.getDate()) months -= 1;
  if (months < 0) months = 0; // created "in the future" (clock skew) → 0mo
  if (months < 12) return `${months}mo`;
  return `${Math.floor(months / 12)}y ${months % 12}m`;
}
